import React from "react";

const SenderIdShimmerComponent = () => {
  return (
    <div className="animate-pulse p-4  space-y-6">
      {/* Stats Section */}
      <div className="grid mb-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array(4)
          .fill("")
          .map((_, index) => (
            <div
              key={index}
              className="bg-gray-200 rounded-lg h-24 w-full shadow"
            ></div>
          ))}
      </div>

      {/* Table Section */}
      <div className="bg-white  rounded-lg shadow p-4">
        {/* Table Header */}
        <div className="grid grid-cols-4 gap-2 mb-4">
          {Array(4)
            .fill("")
            .map((_, index) => (
              <div key={index} className="h-15 bg-gray-200 rounded-md"></div>
            ))}
        </div>

        {/* Table Rows */}
        <div className="space-y-5">
          {Array(6)
            .fill("")
            .map((_, rowIndex) => (
              <div key={rowIndex} className="grid grid-cols-4 gap-2">
                {Array(4)
                  .fill("")
                  .map((_, colIndex) => (
                    <div
                      key={colIndex}
                      className="h-10 bg-gray-200 rounded-md"
                    ></div>
                  ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SenderIdShimmerComponent;
